import React from 'react'
import Styles from './TerminarTrabajoBotes.module.css'
import {Form, Input} from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import SubmitButton from '../../submitButton/submitButton'
import DateUtilities from '../../DateUtilities'

class TerminarTrabajoBote extends React.Component{
	constructor(props){
		super(props)
		this.state={
            fecha: new Date().toISOString().split('T')[0],
			trabajo:props.trabajo,
            mensajes:{
                unidades:false,
            }
        }
    }
    handleChange=(e, {value})=>{
        const state= this.state
        state.trabajo.trabajoHecho=value
        state.trabajo.precio=+(value* this.state.trabajo.precioUnitario).toFixed(2)
        this.setState(state)
    }
    fechaChange=(e, {value})=>{
        const fecha=value
        this.setState({fecha: fecha})
    }
    handleSubmit=async(event)=>{
        event.preventDefault()
        if(this.state.trabajo.trabajoHecho===0){
            const mensajes=this.state.mensajes
            mensajes.unidades=true
            this.setState({mensajes:mensajes})
            return null
        }
        const batch=firebase.firestore().batch()
        const prod = firebase.firestore().collection('Produccion')
        const pagos=firebase.firestore().collection('Pagos')
        const trabajo=this.state.trabajo
        const sector = (await firebase.firestore().collection('Zonas').where('sector', '==', Number(trabajo.area.split('/')[0])).get()).docs[0]
        batch.update(firebase.firestore().collection('TareasAsignadas').doc(trabajo.trabajoID),{
            estado:"completado", 
            precioUnitario:this.state.trabajo.precioUnitario,
            longitudTrabajo:Number(this.state.trabajo.trabajoHecho),
            precioTotal:this.state.trabajo.precio,
            fechaCompletado:DateUtilities.parseDate(this.state.fecha),
        })
        if(!trabajo.nomina || trabajo.nomina==='tarea'){
            for(let i=0; i<trabajo.empleados.length; i++){
                batch.set(pagos.doc(), {
                    trabajoId:trabajo.trabajoID,
                    empleado:trabajo.empleados[i],
                    nombreActividad:trabajo.nombreActividad,
                    descripcion:trabajo.descripcion,
                    trabajoHecho:Number(trabajo.trabajoHecho),
                    dificultad:trabajo.dificultad,
                    unidades:'unidades',
                    precio:trabajo.precio,
                    areaHecha:trabajo.area,
                    numInvolucrados:trabajo.empleados.length,
                    fechaRegistro:new Date(),
                    fecha:DateUtilities.parseDate(this.state.fecha),
                    estado:'pendiente'				
                })
            }
        }
        batch.set(prod.doc(), {
            empleado: trabajo.empleados[0],
            dificultad: trabajo.dificultad,
            nomina: trabajo.nomina,
            totalBotes: Number(trabajo.trabajoHecho),
            sector: sector.data().sector,
            variedad: sector.data().variedad,
            fruta:trabajo.nombreActividad.split('Piscar ')[1],
            fechaRegistro:new Date(),
            fecha:DateUtilities.parseDate(this.state.fecha),
        })
		batch.commit()
        .then(()=>{
		})
        .catch(e=>{
			alert(e)
		})
    }
	render(){
		return(
			<section>
				<Form>
                    <div className={Styles.Inputs}>
                        <div className={Styles.Input}>
                            <p>Botes entregados: </p>
                            <Input type='number' value={this.state.trabajo.trabajoHecho} onChange={this.handleChange}></Input>
                            {
                                this.state.mensajes.unidades?
                                <p className={Styles.message}>Campo Obligatorio</p>
                                :null
                            }
                        </div>
                        <div className={Styles.Input}>
                            <p>precioUnitario</p>
                            <Input value={this.state.trabajo.precioUnitario} disabled></Input>
                        </div>
                        <div className={Styles.Input}>
                            <p>Total</p>
                            <Input value={this.state.trabajo.precio} disabled></Input>
                        </div>
                    </div>
                    <div className={Styles.Input}>
                            <p>Fecha</p>
                            <Input type='date' value={this.state.fecha} onChange={this.fechaChange}></Input>
                        </div>
                    <SubmitButton handleSubmit={this.handleSubmit}>Completar</SubmitButton>
				</Form>
			</section>
		)
	}
}
export default TerminarTrabajoBote